import PropTypes from 'prop-types';
import { forwardRef } from 'react';

import Button from 'shopper/components/Button';

const PageButton = forwardRef(
  ({ children, isActive = false, ...rest }, ref) => (
    <Button
      ref={ref}
      className="mx-1 px-4"
      size="size2"
      type={isActive ? 'neutral-stroke' : 'neutral-ghost'}
      {...rest}
    >
      {children}
    </Button>
  )
);

PageButton.displayName = 'PageButton';

PageButton.propTypes = {
  isActive: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default PageButton;
